
    import {computed, ComputedRef, defineComponent, reactive, watch} from 'vue'
    import {useStore} from "@/store";
    import reportMsgUt from "@/util/reportMsg";
    import {useRoute, useRouter} from "vue-router";
    import { Popup } from 'scvant';

    interface State {
        point: ComputedRef<"N" | "Y">; // N 没有三种缺陷 Y 有三种缺陷
        isAccident: number; // 0不是事故车 1是事故车
        isFire: number; // 0不是事故车 1是事故车
        isWater: number; // 0不是事故车 1是事故车
        reportCode: string | null;
        channelType: string;
        logoUrl: string;
        protectTime: string;
        promiseMsg: string;
        reportMsg: object;
        templateCode: string;
        brandName: string;
        modelName: string;
        vin: string;
        reportGenDate: string;
        showProtect: boolean;
        isXNY: boolean;
        isSF: any;
        productName: string;
        accidentFlag: number;// 0 非事故车 1 非重大事故 2 重大事故车
        showPromiseDes: string;
        rankDesc: any;
    }

    export default defineComponent({
        name: "headTip",
        setup() {
            const {query} = useRoute();
            let state: State = reactive({
                point: "Y" as any,
                isAccident: 1,
                isFire: 1,
                isWater: 1,
                reportCode: '',
                channelType: `${query.channelType}` || '',
                logoUrl: '',
                protectTime: '90',
                promiseMsg: '',
                reportMsg: {},
                templateCode: '',
                brandName: '',
                modelName: '',
                vin: '',
                reportGenDate: '',
                showProtect: false,
                isXNY: false,
                isSF: -1,
                productName: '',
                accidentFlag: 2,
                showPromiseDes: '',
                rankDesc: null,
            })
            state.reportMsg = reportMsgUt;
            state.reportCode = `${query.reportCode}`;
            state.templateCode = `${query.templateCode}`;
            state.protectTime = state.channelType === 'jiaxuan' ? '100' : '90';
            // 获取路由器实例
            const router = useRouter()
            let store = useStore();
            let dataInfo: ComputedRef<{}> = computed<{}>(() => store.state.dataInfo);
            let isNormal: ComputedRef<{}> = computed<{}>(() => store.state.isNormal);
            let reportResultList: ComputedRef<{}> = computed<{}>(() => store.state.reportResultList);
            state.isSF = computed(() => {
                return store.state.isNormal
            });
            state.point = computed(() => {
                return store.state.isNormal ? 'N' : 'Y'
            })
            console.log('reportResultList:', reportResultList);
            // 享90天回购保障{{state.reportMsg.RpSRZ() ? '｜付费享1年３万公里保修' : ''}}
            let promiseDes = `享${state.protectTime}天回购保障`;
            if (state.reportMsg['Rp699']()) {
                promiseDes = `享${state.protectTime}天回购及重要部件赔付保障`;
            } else if (state.reportMsg['RpHC']()) {
                promiseDes = `享${state.protectTime}天赔付保障`;
            }
            state.showPromiseDes = `查看《${promiseDes}说明》`;
            state.promiseMsg = promiseDes + (state.reportMsg['RpSRZ']() ? '｜付费享1年３万公里保修' : '');
            watch(dataInfo, (data: any) => {
                const {isAccident, isFire, isWater, reportConfigInfo, brandName, modelName, vin, reportDetectOrderVO, energyType,productName,accidentFlag, rankDesc} = data;
                state.logoUrl = reportConfigInfo ? reportConfigInfo.logoUrl : '';
                state.isAccident = accidentFlag > -1 ?  accidentFlag : isAccident ;
                state.isFire = isFire
                state.isWater = isWater
                state.brandName = brandName
                state.modelName = modelName
                state.vin = vin;
                state.reportGenDate = reportDetectOrderVO.reportGenDate
                state.isXNY = energyType === 2 ? true : false;
                state.rankDesc = rankDesc;
                // console.log(productName);
                // console.log(accidentFlag);
                //第一版新版报告上线静态化中没有productName字段并且上线的是299相关报告，解析完为undefined,用事故排查检测
                state.productName = productName === undefined ? '事故排查检测' : (productName === null ? '' :productName); 
                state.accidentFlag = accidentFlag;
            })
            
            function getToCV3RectangleStyle(): object  {
                let rectangleStyle = {};
                if (state.reportMsg['Rp299']()) {
                   rectangleStyle = {'tocV3_rectangle_blue': state.isSF, 'tocV3_rectangle_white': !state.isSF};
                } else if (state.reportMsg['Rp499']()) {
                    rectangleStyle = {'tocV3_rectangle_grey': state.isSF, 'tocV3_rectangle_white': !state.isSF};
                } else if (state.reportMsg['Rp699']()) {
                    rectangleStyle = {'tocV3_rectangle_orange': state.isSF, 'tocV3_rectangle_white': !state.isSF};
                } else if (state.reportMsg['RpHC']()) {
                    rectangleStyle = {'tocV3_rectangle_blue': state.isSF, 'tocV3_rectangle_white': !state.isSF};
                } else {
                    rectangleStyle = {'tocV3_rectangle_blue': state.isSF, 'tocV3_rectangle_white': !state.isSF};
                }
                return rectangleStyle;
            }
            function getToCV3RectangleLineStyle(): object  {
                let rectangleLineStyle = {};
                if (state.reportMsg['Rp299']()) {
                   rectangleLineStyle = {'tocV3_rectangle_blue_line': state.isSF, 'tocV3_rectangle_white_line': !state.isSF};
                } else if (state.reportMsg['Rp499']()) {
                    rectangleLineStyle = {'tocV3_rectangle_grey_line': state.isSF, 'tocV3_rectangle_white_line': !state.isSF};
                } else if (state.reportMsg['Rp699']()) {
                    rectangleLineStyle = {'tocV3_rectangle_orange_line': state.isSF, 'tocV3_rectangle_white_line': !state.isSF};
                } else if (state.reportMsg['RpHC']()) {
                    rectangleLineStyle = {'tocV3_rectangle_blue_line': state.isSF, 'tocV3_rectangle_white_line': !state.isSF};
                } else {
                    rectangleLineStyle = {'tocV3_rectangle_blue_line': state.isSF, 'tocV3_rectangle_white_line': !state.isSF};
                }
                return rectangleLineStyle;
            }
            function getToCV3RectangleWhiteLineStyle(): object  {
                let rectangleWhiteLineStyle = {};
                if (state.reportMsg['Rp299']()) {
                   rectangleWhiteLineStyle = {'tocV3_rectangle_blue_white_line': state.isSF, 'tocV3_rectangle_white_white_line': !state.isSF};
                } else if (state.reportMsg['Rp499']()) {
                    rectangleWhiteLineStyle = {'tocV3_rectangle_grey_white_line': state.isSF, 'tocV3_rectangle_white_white_line': !state.isSF};
                } else if (state.reportMsg['Rp699']()) {
                    rectangleWhiteLineStyle = {'tocV3_rectangle_orange_white_line': state.isSF, 'tocV3_rectangle_white_white_line': !state.isSF};
                } else if (state.reportMsg['RpHC']()) {
                    rectangleWhiteLineStyle = {'tocV3_rectangle_blue_white_line': state.isSF, 'tocV3_rectangle_white_white_line': !state.isSF};
                } else {
                    rectangleWhiteLineStyle = {'tocV3_rectangle_blue_white_line': state.isSF, 'tocV3_rectangle_white_white_line': !state.isSF};
                }
                return rectangleWhiteLineStyle;
            }
            function getAccidentDes(): string  {
                let accidentDes = '';
                if (state.accidentFlag === undefined) {//走旧的逻辑
                    accidentDes = !state.isAccident ? '非事故车' : '事故车';
                } else {//根据accidentFlag判断
                    if (state.accidentFlag  === 0) {
                        accidentDes = '非事故车';
                    }  else if (state.accidentFlag  === 1) {
                         accidentDes = '事故车';
                    }  else if (state.accidentFlag  === 2) {
                        accidentDes = '重大事故车';
                    }
                }
                return accidentDes;
            }
            function getToCV3RectangleProtectBorderStyle(): object  {
                let protectBorderStyle = {};
                if (state.reportMsg['Rp499']()) {
                    protectBorderStyle = {'tocV3_rectangle_protect_border_grey': true};
                } else if (state.reportMsg['Rp699']()) {
                    protectBorderStyle = {'tocV3_rectangle_protect_border_orange': true};
                } 
                return protectBorderStyle;
            }
            function getWenLiPic() {
                let wenLiPic = null;
                if (state.reportMsg['Rp499']()) {
                    wenLiPic = require("../../../assets/tocV3/toCV3RectangleWenLiGray.png");
                }else if (state.reportMsg['Rp699']()) {
                    wenLiPic = require("../../../assets/tocV3/toCV3RectangleWenLiOrange.png");
                }
                return wenLiPic;
            }

            return {
                state,
                router,
                dataInfo,
                isNormal,
                reportResultList,
                getToCV3RectangleStyle,
                getToCV3RectangleLineStyle,
                getToCV3RectangleWhiteLineStyle,
                getAccidentDes,
                getToCV3RectangleProtectBorderStyle,
                getWenLiPic,
            }
        },
        components: {
            [Popup.name]: Popup,
        },
        methods: {
            toExplain(desc) {
                if (desc === 'auth') {
                    this.router.push({
                        path: '/explainFreeAuth',
                        query: {
                            templateCode: this.state.templateCode
                        }
                    })
                } else {
                    this.router.push({
                        path: '/tocV3ExplainFreeCheck',
                        query: {
                            channelType: this.state.channelType,
                            templateCode: this.state.templateCode
                        }
                    })
                }
            },
            setShowProtect(){
                let lbParam = {
                    templateCode: this.state.templateCode
                }
                this.state.showProtect = !this.state.showProtect;
            }
        }
    })
